export const SESSION_FEEDBACK_PREFIX = 'session_feedback_stats_';
